// Accounts
const getCoAMainRoute = () => 'accounts'
const getAccountRoute = (accountId = ':accountId') => `accounts/${accountId}`

// Bank ------------------------------------------------------------------------------------------------------------
const getBankMainRoute = (bankAccountId = ':bankAccountId') => `bank_accounts/${bankAccountId}/sync`
const getNoBankAccountsRoute = () => 'bank-accounts/empty'

const getBankAccountsRoute = () => 'bank-accounts'
const getBankTransactionsRoute = () => 'bank-transactions'
// Bills --------------------------------------------------------------------------------------------------------------

const getBillsMainRoute = () => 'bills'
const getBillsSettingsRoute = () => 'bills/settings'
const getBillsCreateCreditNoteRoute = (billIdToCreateCreditNote = ':billIdToCreateCreditNote') =>
  `bills/create-credit-note/${billIdToCreateCreditNote}`
const getBillsDuplicateRoute = (billIdToDuplicate = ':billIdToDuplicate') => `bills/duplicate/${billIdToDuplicate}`
const getBillsEditBillRoute = (billId = ':billId') => `bills/${billId}/edit`
const getBillsEditBulkRoute = (bulkBillId = ':bulkBillId') => `bills/${bulkBillId}/bulk-edit`
const getBillsEditBulkAttachmentsRoute = (attachmentIdBulk = ':attachmentIdBulk') =>
  `bills/${attachmentIdBulk}/bulk-edit-attachments`
const getBillsListEmptyRoute = () => 'bills/empty'
const getBillsNewBillRoute = () => 'bills/new'
const getBillsNewCreditNoteRoute = () => 'bills/new-credit-note'
const getBillsNewBillFromAttachmentRoute = (attachmentId = ':attachmentId') =>
  `bills/new-from-attachment/${attachmentId}`
const getBillsNewBillFromContactRoute = (contactId = ':contactId') => `bills/new-from-contact/${contactId}`
const getBillsViewBillRoute = (billId = ':billId') => `bills/${billId}`

// Cash Pilot ----------------------------------------------------------------------------------------------------------
const getCashPilotMainRoute = () => 'cashpilot'

// Creditors ----------------------------------------------------------------------------------------------------------

const getCreditorsMainRoute = () => 'creditorbalance'
// Vat declarations --------------------------------------------------------------------------------------------------

const getVatDeclarationsEuSalesNoVatRoute = () => 'vat-declarations/eu-sales-no-vat'
const getVatDeclarationsMainRoute = () => 'vat-declarations'
const getVatDeclarationsViewVatDeclarationRoute = (vatDeclarationId = ':vatDeclarationId') =>
  `vat-declarations/${vatDeclarationId}`
// Dashboard ------------------------------------------------------------------------------------------------------------

const getDashboardMainRoute = () => 'dashboard'

// Debtors ------------------------------------------------------------------------------------------------------------

const getDebtorsMainRoute = () => 'debtorbalance'

// E-Invoicing -----------------------------------------------------------------------------------------------------------

const getEInvoicingMainRoute = () => 'e-invoicing'

// Onboarding ------------------------------------------------------------------------------------------------------------

const getOnboardingMainRoute = () => 'onboarding'

// Quick Start ------------------------------------------------------------------------------------------------------------

const getQuickStartMainRoute = () => 'quick-start'

// Exports ------------------------------------------------------------------------------------------------------------

const getExportsMainRoute = () => 'exports'

// Find Accountant ------------------------------------------------------------------------------------------------------------

const getFindAccountantMainRoute = () => 'find-accountant'

// My Client ----------------------------------------------------------------------------------------------------------

const getMyClientMainRoute = () => 'expert/my-client'

// Suppliers Balance ----------------------------------------------------------------------------------------------------------

const getSuppliersBalanceMainRoute = (id = ':id') => 'expert/suppliers-balance'
const getSuppliersBalanceDetailRoute = (id = ':id') => `expert/suppliers-balance/${id}`

// Customers Balance ----------------------------------------------------------------------------------------------------------

const getCustomersBalanceMainRoute = () => 'expert/customers-balance'
const getCustomersBalanceDetailRoute = (id = ':id') => `expert/customers-balance/${id}`

// Expert Trial Balance -------------------------------------------------------------------------------------------------------

const getExpertTrialBalanceMainRoute = () => 'expert/trial-balance'

// Expert Profit and Loss -----------------------------------------------------------------------------------------------------

const getExpertProfitAndLossMainRoute = () => 'expert/profit-and-loss'

// Expert Balance Sheet -------------------------------------------------------------------------------------------------------

const getExpertBalanceSheetMainRoute = () => 'expert/balance-sheet'

// Expert Vat Declarations --------------------------------------------------------------------------------------------------

const getExpertVatDeclarationsEuSalesNoVatRoute = () => 'expert/vat-declarations/eu-sales-no-vat'
const getExpertVatDeclarationsMainRoute = () => 'expert/vat-declarations'
const getExpertVatDeclarationsViewVatDeclarationRoute = (vatDeclarationId = ':vatDeclarationId') =>
  `expert/vat-declarations/${vatDeclarationId}`
const getExpertVatSuggestionsMainRoute = (vatDeclarationId = ':vatDeclarationId') =>
  `expert/vat-declarations/${vatDeclarationId}/suggestions/`

// Expert Documents --------------------------------------------------------------------------------------------------

const getExpertDocumentsMainRoute = () => 'expert/documents'
const getExpertDocumentsFolderRoute = (folderId = ':folderId', slug?: string) =>
  slug ? `expert/documents/folders/${folderId}/${slug}` : `expert/documents/folders/${folderId}`
const getExpertDocumentsUnsortedRoute = () => 'expert/documents/unsorted'
const getExpertDocumentsDocumentRoute = (documentId = ':documentId') => `expert/documents/document/${documentId}`

// Client Documents --------------------------------------------------------------------------------------------------

const getClientDocumentsMainRoute = () => 'documents'
const getClientDocumentsFolderRoute = (folderId = ':folderId', slug?: string) =>
  slug ? `documents/folders/${folderId}/${slug}` : `documents/folders/${folderId}`
const getClientDocumentsSharedByMeRoute = () => 'documents/shared'
const getClientDocumentsDocumentRoute = (documentId = ':documentId') => `documents/document/${documentId}`

// Invoicing documents --------------------------------------------------------------------------------------------------

//   Document list .................................................................................................

const getDeliveryNotesMainRoute = () => 'delivery-notes'

const getInvoicesMainRoute = () => 'invoices'
const getInvoicesListEmptyRoute = () => 'invoices/empty'

const getQuotesMainRoute = () => 'quotes'
const getQuotesListEmptyRoute = () => 'quotes/empty'

const getRecurringInvoicesMainRoute = () => 'recurring-invoices'

//   Document page .................................................................................................

const getInvoicesViewInvoiceRoute = (
  invoiceDocumentId = ':invoiceDocumentId',
  invoiceDocumentType = ':invoiceDocumentType',
) => `invoices/${invoiceDocumentId}/${invoiceDocumentType}`

const getQuotesViewQuoteRoute = (quoteId = ':quoteId') => `quotes/${quoteId}`

const getRecurringInvoicesViewRecurringInvoiceRoute = (recurringInvoiceId = ':recurringInvoiceId') =>
  `recurring-invoices/view/${recurringInvoiceId}`

//   Editor .................................................................................................

const getInvoicesNewDocumentRoute = (documentRouteBase = ':documentRouteBase') => `${documentRouteBase}/new`
const getInvoicesEditDocumentDraftRoute = (documentRouteBase = ':documentRouteBase', documentId = ':documentId') =>
  `${documentRouteBase}/${documentId}/draft/edit`
const getInvoicesEditDocumentRoute = (documentRouteBase = ':documentRouteBase', documentId = ':documentId') =>
  `${documentRouteBase}/${documentId}/edit`
const getInvoicesDuplicateDocumentRoute = (documentRouteBase = ':documentRouteBase', documentId = ':documentId') =>
  `${documentRouteBase}/${documentId}/duplicate`
const getInvoicesDuplicateDocumentDraftRoute = (documentRouteBase = ':documentRouteBase', documentId = ':documentId') =>
  `${documentRouteBase}/${documentId}/draft/duplicate`

const getInvoicesCreditNoteFromInvoiceRoute = (invoiceId = ':documentId') => `invoices/${invoiceId}/new-creditnote`
const getInvoicesInvoiceFromQuoteRoute = (documentId = ':documentId') => `invoices/new-invoice-from-quote/${documentId}`
const getInvoicesDepositInvoiceFromQuoteRoute = (documentId = ':documentId') =>
  `invoices/new-deposit-invoice-from-quote/${documentId}`
const getInvoicesFinalInvoiceFromQuoteRoute = (documentId = ':documentId') =>
  `invoices/new-final-invoice-from-quote/${documentId}`
const getInvoicesEditDepositInvoiceDraftRoute = (documentId = ':documentId') =>
  getInvoicesEditDocumentRoute('invoices/deposit-invoice-draft', documentId)
const getInvoicesEditFinalInvoiceDraftRoute = (documentId = ':documentId') =>
  getInvoicesEditDocumentRoute('invoices/final-invoice-draft', documentId)

// Demo invoice ------------------------------------------------------------------------------------------------------

const getDemoInvoiceMainRoute = () => 'demo-invoice'

// Salary ------------------------------------------------------------------------------------------------------------

const getSalaryMainRoute = () => 'salary'

// Things to do ------------------------------------------------------------------------------------------------------

const getThingsToDoMainRoute = () => 'things-to-do'

// Uploads -----------------------------------------------------------------------------------------------------------

const getUploadsMainRoute = () => 'uploads'

// Debug ------------------------------------------------------------------------------------------------------------

const getDebugMainRoute = () => 'debug'

// Products ------------------------------------------------------------------------------------------------------------

const getProductsMainRoute = () => 'products'

// VAT Suggestions ------------------------------------------------------------------------------------------------------

const getVatSuggestionsMainRoute = (vatDeclarationId = ':vatDeclarationId') =>
  `vat-declarations/${vatDeclarationId}/suggestions/`

// Sales Reports --------------------------------------------------------------------------------------------------------

const getReportsSalesReportRoute = () => 'sales-report'
const getReportsSalesOverviewReportRoute = () => 'sales-report/overview'
const getReportsSalesByCustomerRoute = () => 'sales-report/by-customer'
const getReportsSalesByItemRoute = () => 'sales-report/by-item'
const getReportsSalesReportEmptyRoute = () => 'sales-report/empty'

// Reports --------------------------------------------------------------------------------------------------------------

const getReportsMainRoute = () => 'reports-all'
const getReportsProfitAndLossRoute = () => 'reports-all/profit-and-loss'
const getReportsTrialBalanceRoute = () => 'reports-all/trial-balance'
const getReportsBalanceSheetRoute = () => 'reports-all/balance'

const getTransactionMainRoute = () => 'transactions'

const getReviewEntriesMainRoute = () => 'expert/review-entries'

const getImportedInvoicesMainRoute = () => 'imported-invoices'

export const reactRoute = {
  organization: {
    accounts: {
      getAccountRoute,
    },
    bank: {
      getMainRoute: getBankMainRoute,
      getNoBankAccountsRoute,
      getBankAccountsRoute,
      getBankTransactionsRoute,
    },
    chartOfAccounts: {
      getMainRoute: getCoAMainRoute,
    },
    transactions: {
      getMainRoute: getTransactionMainRoute,
    },
    bills: {
      getMainRoute: getBillsMainRoute,
      getSettingsRoute: getBillsSettingsRoute,
      getCreateCreditNoteRoute: getBillsCreateCreditNoteRoute,
      getDuplicateRoute: getBillsDuplicateRoute,
      getEditBillRoute: getBillsEditBillRoute,
      getEditBulkRoute: getBillsEditBulkRoute,
      getEditBulkAttachmentsRoute: getBillsEditBulkAttachmentsRoute,
      getListEmptyRoute: getBillsListEmptyRoute,
      getNewBillRoute: getBillsNewBillRoute,
      getNewCreditNoteRoute: getBillsNewCreditNoteRoute,
      getNewBillFromAttachmentRoute: getBillsNewBillFromAttachmentRoute,
      getNewBillFromContactRoute: getBillsNewBillFromContactRoute,
      getViewBillRoute: getBillsViewBillRoute,
    },
    clients: {
      getMainRoute: () => 'clients',
      getListEmptyRoute: () => 'clients/empty',
      getViewClientRoute: (clientId = ':clientId') => `clients/${clientId}`,
      getEditClientRoute: (clientId = ':clientId') => `clients/${clientId}/edit`,
    },
    suppliers: {
      getMainRoute: () => 'suppliers',
      getListEmptyRoute: () => 'suppliers/empty',
      getSupplierDetailRoute: (supplierId = ':supplierId') => `suppliers/${supplierId}`,
    },
    suppliersBalance: {
      getMainRoute: getSuppliersBalanceMainRoute,
      getDetailRoute: getSuppliersBalanceDetailRoute,
    },
    customersBalance: {
      getMainRoute: getCustomersBalanceMainRoute,
      getDetailRoute: getCustomersBalanceDetailRoute,
    },
    expertTrialBalance: {
      getMainRoute: getExpertTrialBalanceMainRoute,
    },
    expertProfitAndLoss: {
      getMainRoute: getExpertProfitAndLossMainRoute,
    },
    expertBalanceSheet: {
      getMainRoute: getExpertBalanceSheetMainRoute,
    },
    expertVatDeclarations: {
      getEuSalesNoVatRoute: getExpertVatDeclarationsEuSalesNoVatRoute,
      getMainRoute: getExpertVatDeclarationsMainRoute,
      getSuggestionsMainRoute: getExpertVatSuggestionsMainRoute,
      getViewVatDeclarationRoute: getExpertVatDeclarationsViewVatDeclarationRoute,
    },
    cashpilot: {
      getMainRoute: getCashPilotMainRoute,
    },
    creditors: {
      getMainRoute: getCreditorsMainRoute,
    },
    dashboard: {
      getMainRoute: getDashboardMainRoute,
    },
    debtors: {
      getMainRoute: getDebtorsMainRoute,
    },
    debug: {
      getMainRoute: getDebugMainRoute,
    },
    demoInvoice: {
      getMainRoute: getDemoInvoiceMainRoute,
    },
    eInvoicing: {
      getMainRoute: getEInvoicingMainRoute,
    },
    onboarding: {
      getMainRoute: getOnboardingMainRoute,
    },
    quickStart: {
      getMainRoute: getQuickStartMainRoute,
    },
    exports: {
      getMainRoute: getExportsMainRoute,
    },
    findAccountant: {
      getMainRoute: getFindAccountantMainRoute,
    },
    helpCenter: {
      getMainRoute: () => 'help-center',
    },
    myClient: {
      getMainRoute: getMyClientMainRoute,
    },
    documents: {
      getMainRoute: getExpertDocumentsMainRoute,
      getFolderRoute: getExpertDocumentsFolderRoute,
      getUnsortedRoute: getExpertDocumentsUnsortedRoute,
      getDocumentRoute: getExpertDocumentsDocumentRoute,
    },
    clientDocuments: {
      getMainRoute: getClientDocumentsMainRoute,
      getFolderRoute: getClientDocumentsFolderRoute,
      getSharedByMeRoute: getClientDocumentsSharedByMeRoute,
      getDocumentRoute: getClientDocumentsDocumentRoute,
    },
    importedInvoices: {
      getMainRoute: getImportedInvoicesMainRoute,
    },
    deliveryNotes: {
      getMainRoute: getDeliveryNotesMainRoute,
    },
    invoices: {
      getMainRoute: getInvoicesMainRoute,
      getListEmptyRoute: getInvoicesListEmptyRoute,
      getViewInvoiceRoute: getInvoicesViewInvoiceRoute,
      getNewDocumentRoute: getInvoicesNewDocumentRoute,
      getEditDocumentDraftRoute: getInvoicesEditDocumentDraftRoute,
      getEditDocumentRoute: getInvoicesEditDocumentRoute,
      getDuplicateDocumentRoute: getInvoicesDuplicateDocumentRoute,
      getDuplicateDocumentDraftRoute: getInvoicesDuplicateDocumentDraftRoute,
      getCreditNoteFromInvoiceRoute: getInvoicesCreditNoteFromInvoiceRoute,
      getDepositInvoiceFromQuoteRoute: getInvoicesDepositInvoiceFromQuoteRoute,
      getFinalInvoiceFromQuoteRoute: getInvoicesFinalInvoiceFromQuoteRoute,
      getEditDepositInvoiceDraftRoute: getInvoicesEditDepositInvoiceDraftRoute,
      getEditFinalInvoiceDraftRoute: getInvoicesEditFinalInvoiceDraftRoute,
      getInvoiceFromQuoteRoute: getInvoicesInvoiceFromQuoteRoute,
    },
    products: {
      getMainRoute: getProductsMainRoute,
    },
    reports: {
      getMainRoute: getReportsMainRoute,
      getProfitAndLossRoute: getReportsProfitAndLossRoute,
      getTrialBalanceRoute: getReportsTrialBalanceRoute,
      getBalanceSheetRoute: getReportsBalanceSheetRoute,
    },
    quotes: {
      getMainRoute: getQuotesMainRoute,
      getListEmptyRoute: getQuotesListEmptyRoute,
      getViewQuoteRoute: getQuotesViewQuoteRoute,
    },
    recurringInvoices: {
      getMainRoute: getRecurringInvoicesMainRoute,
      getViewRecurringInvoiceRoute: getRecurringInvoicesViewRecurringInvoiceRoute,
    },
    reviewEntries: {
      getMainRoute: getReviewEntriesMainRoute,
    },
    salesReport: {
      getMainRoute: getReportsSalesReportRoute,
      getListEmptyRoute: getReportsSalesReportEmptyRoute,
      getSalesByCustomerRoute: getReportsSalesByCustomerRoute,
      getSalesByItemRoute: getReportsSalesByItemRoute,
      getSalesOverviewRoute: getReportsSalesOverviewReportRoute,
    },
    vatSuggestions: {
      getMainRoute: getVatSuggestionsMainRoute,
    },
    thingsToDo: {
      getMainRoute: getThingsToDoMainRoute,
    },
    uploads: {
      getMainRoute: getUploadsMainRoute,
    },
    salary: {
      getMainRoute: getSalaryMainRoute,
    },
    vatDeclarations: {
      getEuSalesNoVatRoute: getVatDeclarationsEuSalesNoVatRoute,
      getMainRoute: getVatDeclarationsMainRoute,
      getSuggestionsMainRoute: getVatSuggestionsMainRoute,
      getViewVatDeclarationRoute: getVatDeclarationsViewVatDeclarationRoute,
    },
  },
}
